<template>
  <div>
    <b-tabs
      nav-class="nav-left"
      content-class="col-12 col-md-9 mt-1 mt-md-0"
      nav-wrapper-class="col-md-3 col-12"
      pills
      vertical
    >
      <b-tab>
        <template #title>
          <span class="font-weight-bold">
            <feather-icon icon="SettingsIcon" />
            {{ $t("General Settings") }}
          </span>
        </template>

        <general-settings />
      </b-tab>

      <b-tab v-if="canUpdateProductivity">
        <template #title>
          <span
            id="tour-productive-rating-tab"
            class="font-weight-bold"
          >
            <feather-icon icon="ZapIcon" />
            {{ $t("Productive Rating") }}
          </span>
        </template>

        <productive-rating />
      </b-tab>
      <b-tab v-if="canUpdateProductivity">
        <template #title>
          <span class="font-weight-bold">
            <feather-icon icon="TagIcon" />
            {{ $t("User Tags") }}
          </span>
        </template>

        <user-tags />
      </b-tab>

      <b-tab
        v-if="canEditTimeLimits"
        disabled
      >
        <template #title>
          <hr style="width: 20%">
          <span class="font-weight-bold">{{ $t('User Level Settings') }}</span>
          <hr style="width: 20%">
        </template>
      </b-tab>

      <!-- Time Limit Settings -->
      <b-tab
        v-if="canEditTimeLimits"
        lazy
      >
        <template #title>
          <span class="font-weight-bold">
            <feather-icon icon="ClockIcon" />
            {{ $t('Time Limit Settings') }}
          </span>
        </template>

        <time-limit-settings />
      </b-tab>

      <!-- Change User Status -->
      <b-tab
        v-if="canManageUsers"
        lazy
      >
        <template #title>
          <span class="font-weight-bold">
            <feather-icon icon="UserCheckIcon" />
            {{ $t('Change User Status') }}
          </span>
        </template>

        <user-status-settings />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import { BTabs, BTab } from 'bootstrap-vue'
import ProductiveRating from '@/views/Settings/ProductiveRating/index.vue'
import UserTags from '@/views/Settings/UserTags/index.vue'
import { mapActions, mapGetters } from 'vuex'
import { checkPermission } from '@/utils/permissions'
import EventBus from '@/event-bus'
import GeneralSettings from './components/GeneralSettings.vue'
import TimeLimitSettings from './components/TimeLimitSettings.vue'
import UserStatusSettings from './components/UserStatusSettings.vue'

export default {
  components: {
    BTabs,
    BTab,
    GeneralSettings,
    ProductiveRating,
    UserTags,
    UserStatusSettings,
    TimeLimitSettings,
  },
  data() {
    return {
      permissions: [
        'productivity.update',
        'timing.limit',
        'project.manageusers',
      ],
      needPermissionCheck: false,
    }
  },
  computed: {
    ...mapGetters('permissions', ['canUpdateProductivity', 'canEditTimeLimits', 'canManageUsers']),
    requireUserPermissionCheck() {
      return !(
        this.canUpdateProductivity
        && this.canEditTimeLimits
        && this.canManageUsers
      )
    },
  },
  mounted() {
    EventBus.$on('permission-updated', permission => {
      if (this.permissions.indexOf(permission) !== -1) {
        this.needPermissionCheck = true
        setTimeout(() => {
          this.checkUserPermissions()
        }, 2000)
      }
    })

    this.checkUserPermissions()
  },
  beforeDestroy() {
    EventBus.$off('permission-updated')
  },
  methods: {
    ...mapActions('permissions', ['setPermissions']),
    checkUserPermissions() {
      if (this.requireUserPermissionCheck || this.needPermissionCheck) {
        checkPermission(this.permissions, permissions => {
          const canUpdateProductivity = permissions['productivity.update'] === true
          const canEditTimeLimits = permissions['timing.limit'] === true
          const canManageUsers = permissions['project.manageusers'] === true

          const payload = [
            { key: 'setProductivityEditPermission', value: canUpdateProductivity },
            { key: 'setTimeLimitsPermission', value: canEditTimeLimits },
            { key: 'setManageUserPermission', value: canManageUsers },
          ]
          this.setPermissions(payload)
          this.needPermissionCheck = false
        })
      }
    },
  },
}
</script>
